import React from 'react'

import { Tooltip } from '@material-ui/core'
import Button from '@material-ui/core/Button'
import { makeStyles } from '@material-ui/core/styles'
import { useTranslate } from 'react-admin'

import { lightergray2, normalGray } from '../../constants/colorConstants'
import Info from '../../images/info'
import { CurrencyField } from './currencyField'

const useStyles = makeStyles((theme) => ({
  remainingBalancePanel: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'flex-end',
    alignItems: 'center',
  },
  required: {
    fontSize: '11px',
    lineHeight: '12.89px',
    ...theme.mundi.font.roboto400Normal,
    color: normalGray,
  },
  invisible: {
    fontSize: '11px',
    lineHeight: '12.89px',
    ...theme.mundi.font.roboto400Normal,
    color: normalGray,
    opacity: 0,
  },
  nohover: {
    '&:hover': {
      backgroundColor: 'transparent!important',
    },
  },
}))

export const RemainingBalanceField = (props) => {
  const classes = useStyles()
  const translate = useTranslate()

  const status = props.record?.status
  const tooltipVisibility =
    status === 'REQUESTED' ||
    status === 'PENDING REVIEW' ||
    status === 'APPROVED'
  let hoverTextResource = ''
  if (status === 'REQUESTED' || status === 'PENDING REVIEW')
    hoverTextResource =
      'resources.invoices.messages.remainingBalanceRequestedHoverText'
  if (status === 'APPROVED')
    hoverTextResource =
      'resources.invoices.messages.remainingBalanceApprovedHoverText'

  return (
    <div className={classes.remainingBalancePanel}>
      <CurrencyField {...props} />
      <Tooltip
        className={tooltipVisibility ? classes.required : classes.invisible}
        title={tooltipVisibility ? translate(hoverTextResource) : undefined}
      >
        <Button className={classes.nohover} disabled={!tooltipVisibility}>
          <Info color={lightergray2} />
        </Button>
      </Tooltip>
    </div>
  )
}
